export const iconFontAwesomeTextformattingTableColumns = (
	<i className="fa-solid fa-table-columns"></i>
);
